import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';

const propTypes = {
  route: PropTypes.object.isRequired,
};

const CardTemplateCreatorMasterView = ({ route }) => {
  return <Fragment>{renderRoutes(route.routes)}</Fragment>;
};

CardTemplateCreatorMasterView.propTypes = propTypes;

export default compose(withRouter)(CardTemplateCreatorMasterView);
